import styled from "styled-components";
import {
  cuideoTheme,
  COLOR_BORDER,
  COLOR_TEXT_MUTED,
} from "../../../../containers/themes/defaultTheme";

export const WheelMask = styled.div<{ $itemHeight: number; $visible: number }>`
  position: relative;
  width: 3.5rem;
  height: ${({ $itemHeight, $visible }) => $itemHeight * $visible}px;
  overflow: hidden;
  /* Líneas que delimitan la celda central (el valor seleccionado). */
  &::before,
  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    height: 1px;
    background: ${COLOR_BORDER};
    z-index: 1;
    pointer-events: none;
  }
  &::before {
    top: ${({ $itemHeight, $visible }) =>
      $itemHeight * Math.floor($visible / 2)}px;
  }
  &::after {
    top: ${({ $itemHeight, $visible }) =>
      $itemHeight * (Math.floor($visible / 2) + 1)}px;
  }
`;

export const WheelList = styled.div<{ $itemHeight: number; $visible: number }>`
  box-sizing: border-box;
  height: 100%;
  overflow-y: scroll;
  scroll-snap-type: y mandatory;
  padding: ${({ $itemHeight, $visible }) =>
      $itemHeight * Math.floor($visible / 2)}px
    0;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
  &:focus {
    outline: none;
  }
  &:focus-visible {
    outline: 2px solid ${cuideoTheme.palette.secondary.main};
    outline-offset: -2px;
    border-radius: 4px;
  }
`;

export const WheelItem = styled.div<{
  $itemHeight: number;
  $selected: boolean;
}>`
  height: ${({ $itemHeight }) => $itemHeight}px;
  display: flex;
  align-items: center;
  justify-content: center;
  scroll-snap-align: center;
  cursor: pointer;
  font-family: "Source Sans Pro", Helvetica, Arial, sans-serif;
  font-size: ${({ $selected }) => ($selected ? "2rem" : "1.5rem")};
  font-weight: ${({ $selected }) => ($selected ? 700 : 400)};
  color: ${({ $selected }) =>
    $selected ? cuideoTheme.palette.primary.main : COLOR_TEXT_MUTED};
  transition: color 0.15s, font-size 0.15s;
`;
